import axios from 'axios';
import { API_URL } from '../config';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: `${API_URL}`,
  headers: { 'Content-Type': 'application/json' }
});

// Add request interceptor to include JWT token in all requests
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

export const chatTitleService = {
  setTitle: async (sessionId, title) => {
    const response = await api.post(`/chat/${sessionId}/title`, { title });
    return response.data;
  },
  getTitle: async (sessionId) => {
    const response = await api.get(`/chat/${sessionId}/title`);
    return response.data;
  }
};
